document.addEventListener("turbolinks:load", function() {
    const $body = $("body");
    const controller = ($body.attr("data-controller") || "").trim();
    const action = ($body.attr("data-action") || "").trim();
    const role = ($body.attr("data-user_role") || "").trim();
    
    console.log("Dashboard JS Init:", { controller, action, role });

    const isAdmin = (role == "admin" || role == "super_admin" || role == "manager");
    const isPerformancePage = (controller == "statistics" && action == "performance");
    const isAvisPage = (controller == "statistics" && action == "avis");

    if (!isAdmin && !isPerformancePage && !isAvisPage) return;

    // --- Shared Utilities ---
    const charts = {}; // Store Highcharts instances

    function reservation(date) {
        if ($('#chart_workshops_remaining_slots').length === 0) return;
        JsLoadingOverlay.show({
            'overlayBackgroundColor': '#666666',
            'overlayOpacity': 0.6,
            'spinnerIcon': 'ball-atom',
            'spinnerColor': '#000',
            'spinnerSize': '2x',
            'containerID': "remaining_container"
        });

        if (!date) {
            date = moment(new Date()).format("YYYY-MM-DD");
        }

        fetch(`/workshops/remaining_slots/${date}`, {
            method: 'PUT',
            mode: 'cors',
            cache: 'default',
        }).then(response => {
            if (response.ok) {
                response.json().then(data => {
                    const chart = Highcharts.chart('chart_workshops_remaining_slots', {
                        chart: { type: 'column' },
                        title: { text: null },
                        xAxis: { categories: data.services, crosshair: true },
                        yAxis: { min: 0, title: { text: 'Nombre' } },
                        tooltip: { valueSuffix: ' {series.name}' },
                        plotOptions: { column: { pointPadding: 0.2, borderWidth: 0 } },
                        series: [
                            { name: 'Max', data: data.max_slots },
                            { name: 'Réservé(s)', data: data.remains, color: '#f1c40f' }
                        ],
                        credits: { enabled: false }
                    });
                    charts['chart_workshops_remaining_slots'] = chart;
                    JsLoadingOverlay.hide();
                });
            }
        }).catch(() => JsLoadingOverlay.hide());
    }

    function initChart(id, type, data) {
        if (!data || !document.getElementById(id)) return;
        let options = {
            title: { text: null },
            credits: { enabled: false }
        };

        if (type === 'car_models') {
            options.chart = { type: 'bar', height: (Object.keys(data).length * 40) + 100 }; // Dynamic height
            options.xAxis = { 
                categories: Object.keys(data),
                title: { text: null },
                labels: { style: { fontWeight: 'bold' } }
            };
            options.yAxis = {
                title: { text: 'Nombre de rendez-vous', align: 'high' },
                labels: { overflow: 'justify' },
                allowDecimals: false
            };
            options.plotOptions = {
                bar: {
                    dataLabels: {
                        enabled: true,
                        format: '{y}',
                        style: { fontWeight: 'bold', color: '#fff' }
                    },
                    borderRadius: 5,
                    colorByPoint: true
                }
            };
            options.series = [{ 
                name: 'Rendez-vous', 
                data: Object.values(data),
                color: '#3498db'
            }];
            options.tooltip = {
                headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
                pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b>'
            };
            options.colors = ['#2ecc71', '#3498db', '#9b59b6', '#f1c40f', '#e67e22', '#e74c3c', '#1abc9c', '#d35400'];
        } else if (type === 'services') {
            options.chart = { type: 'pie', height: 300 };
            options.plotOptions = {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: { 
                        enabled: true, 
                        format: '<b>{point.name}</b>: {point.y}', 
                        distance: 20,
                        style: {
                            textOutline: 'none',
                            color: '#ffffff',
                            fontSize: '13px'
                        }
                    }
                }
            };
            options.series = [{
                name: 'Services',
                colorByPoint: true,
                data: Object.entries(data).map(([name, count]) => ({ name, y: count }))
            }];
        } else if (type === 'days') {
            options.chart = { type: 'column' };
            options.xAxis = { categories: Object.keys(data) };
            options.series = [{ name: 'Volume', data: Object.values(data), color: '#2ecc71' }];
        } else if (type === 'hours') {
            options.chart = { type: 'line' };
            options.xAxis = { categories: Object.keys(data) };
            options.series = [{ name: 'Volume', data: Object.values(data), color: '#e67e22' }];
        } else if (type === 'ratings_evolution') {
            options.chart = { type: 'line' };
            options.xAxis = { categories: data.months, labels: { rotation: -45 } };
            options.yAxis = { min: 0, max: 5, title: { text: 'Note Moyenne' } };
            options.tooltip = { shared: true, crosshairs: true };
            options.series = data.series;
        }

        charts[id] = Highcharts.chart(id, options);
    }

    function updateChart(id, type, data) {
        const chart = charts[id];
        if (!chart) return;

        if (type === 'services') {
            const seriesData = Object.entries(data).map(([name, count]) => ({ name, y: count }));
            chart.series[0].setData(seriesData);
        } else if (type === 'workshops') {
            chart.xAxis[0].setCategories(data.services);
            chart.series[0].setData(data.max_slots);
            chart.series[1].setData(data.remains);
        } else {
            if (type === 'ratings_evolution') {
                chart.xAxis[0].setCategories(data.months);
                data.series.forEach((s, i) => {
                    if (chart.series[i]) chart.series[i].setData(s.data);
                });
            } else {
                chart.xAxis[0].setCategories(Object.keys(data));
                chart.series[0].setData(Object.values(data));
            }
            if (type === 'car_models') {
                chart.setSize(null, (Object.keys(data).length * 40) + 100);
            }
        }
    }

    function triggerRefresh(input) {
        const card = input.closest('.card2');
        const btn = card.find('.refresh-chart');
        if (btn.length) {
            btn[0].click();
        }
    }

    // --- Dashboard Specific Logic ---
    const isDashboard = (controller == "home" && action == "index");
    const isSmsPage = (controller == "statistics" && action == "sms");

    if ((isDashboard || isSmsPage) && $('#table-smslog').length > 0) {
        $('#table-smslog').DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            ajax: { url: $('#table-smslog').data('source') },
            columns: [
                {data: "id" }, { data: "user" }, { data: "phone" }, { data: "message_id" }, { data: "response" },
                { 
                    data: "date",
                    render: function(data, type, row) {
                        return row.date ? moment.utc(new Date(row.date)).format("LLL") : '-';
                    }
                },
                { data: "description" }
            ],
            language: { url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json' }
        });

        $("#reload_smslog").on("click", function() {
            JsLoadingOverlay.show({ 'overlayBackgroundColor': '#666666' });
            fetch(`/acknowledgement`).then(() => {
                $('#table-smslog').DataTable().ajax.reload();
                JsLoadingOverlay.hide();
            });
        });
    }

    // Common Workshop initialization
    if ($('#chart_workshops_remaining_slots').length > 0) {
        reservation();
    }

    // Dashboard standard datepicker logic
    if ($('#chart_workshops_remaining_slots_date').length > 0 && !isPerformancePage) {
        $('#chart_workshops_remaining_slots_date').datepicker({
            format: 'dd/mm/yyyy',
            autoclose: true,
            todayHighlight: true
        }).on("changeDate", function() {
            let date = moment(new Date($(this).datepicker("getDate"))).format("YYYY-MM-DD");
            reservation(date);
        }).datepicker("setDate", "0");
    }

    // --- Performance & Avis Page Specific Logic ---
    if (isPerformancePage || isAvisPage) {
        const stats = window.performance_stats || {};
        
        // Lazy initialization for Range Pickers (Flatpickr)
        $(document).on('focus', '.date-range-picker:not(.flatpickr-input)', function() {
            if (typeof flatpickr !== 'undefined') {
                flatpickr(this, {
                    mode: "range",
                    dateFormat: "Y-m-d",
                    locale: typeof flatpickr.l10ns !== 'undefined' && flatpickr.l10ns.fr ? "fr" : "default",
                    onChange: function(selectedDates, dateStr, instance) {
                        if (selectedDates.length === 2) {
                            triggerRefresh($(instance.element));
                        }
                    }
                }).open();
            }
        });

        // Lazy initialization for Single Date (Datepicker)
        $(document).on('focus', '.single-date-picker:not(.hasDatepicker)', function() {
            if ($.fn.datepicker) {
                $(this).datepicker({
                    format: 'dd/mm/yyyy',
                    autoclose: true,
                    todayHighlight: true,
                    language: 'fr'
                }).on("changeDate", function() {
                    const dateVal = $(this).val();
                    let formattedDate = dateVal;
                    if (dateVal && dateVal.includes("/")) {
                        const [d, m, y] = dateVal.split("/");
                        formattedDate = `${y}-${m}-${d}`;
                    }
                    reservation(formattedDate);
                }).datepicker('show');
            }
        });

        // Initial chart load
        initChart('chart_car_models', 'car_models', stats.car_models);
        initChart('chart_services_dist', 'services', stats.services);
        initChart('chart_peak_days', 'days', stats.days);
        initChart('chart_peak_hours', 'hours', stats.hours);
        initChart('chart_ratings_evolution', 'ratings_evolution', stats.ratings_evolution);

        // Universal AJAX Refresh handler
        $(document).on("click", ".refresh-chart", function() {
            const btn = $(this);
            const chartId = btn.data("chart-id");
            const chartType = btn.data("chart-type");
            const card = btn.closest('.card2');
            
            if (chartType === 'workshops') return; 

            const picker = card.find('.date-range-picker');
            const dateVal = picker.val();
            let params = `type=${chartType}`;
            
            if (dateVal) {
                const parts = dateVal.split(/\s+to\s+|\s+au\s+/);
                if (parts.length === 2) {
                    params += `&start_date=${parts[0]}&end_date=${parts[1]}`;
                }
            }

            if (chartType === 'car_models') {
                params += `&limit=${$("#car_models_limit").val()}`;
            }

            JsLoadingOverlay.show({ 'overlayBackgroundColor': '#666666', 'containerID': card.attr('id') || null });

            fetch(`/statistics/chart_data?${params}`)
                .then(r => r.json())
                .then(data => {
                    updateChart(chartId, chartType, data);
                    JsLoadingOverlay.hide();
                }).catch(() => JsLoadingOverlay.hide());
        });

        $(document).on("change", "#car_models_limit", function () {
            triggerRefresh($(this));
        });
    }
});
